<template>
  <div class="ma-0 pa-0" :class="isOnMobile ? 'box-container' : 'box-container-horizontal'" style="width: 100%; height: 100%" :style="isOnMobile ? 'flex-direction: column-reverse;' : ''">
    <div class="row-header ma-0 pa-0">
      <device-list class="ma-0 pa-0 px-1 pt-2" v-model="selectedDev" :showAll="true" :devices="devices" :width="isOnMobile ? '100%' : 270" :height="isOnMobile ? 300 : '100%'"></device-list>
    </div>
    <div class="row-content ma-0 pa-0">
      <v-row class="ma-2 pa-0">
        <v-select
          class="ma-2 pa-0 subtitle-2"
          v-model="val"
          return-object
          :items="MM_YY"
          clearable
          :label="TR.YearAndMonth"
          item-text="name"
          item-value="value"
          hide-details
          dense
          :no-data-text="TR.NoData"
          :item-color="isInDarkMode ? '#FFFFFF' : ''"
          style="width: 200px; max-width: 200px"
        >
        </v-select>
        <t-button :btnDisabled="!val" btnText="Descarcati fisiere xml ANAF" btnIcon="mdi-download" @click.native="downloadAll()" />
      </v-row>
    </div>
  </div>
</template>

<script>
import DataManager from "../../js/DataManager";
import HTTPSender from "../../js/HTTPSender";
import { g_Dialog, TR } from "../../main";

export default {
  data: () => {
    return {
      title: null,
      message: null,
      selectedDev: null,
      val: null,
      MM_YY: [],
      TR: TR,
    };
  },
  computed: {
    devices() {
      return DataManager.getSubscribedDevs(true);
    },
  },
  methods: {
    // setTitleAndData(meta, error) {
    //   this.title = meta.title;
    //   if (error.ErrorCode != ErrorMessage.ERROR_CODE_OK) {
    //     this.message = error.Message;
    //   }
    // },
    async downloadAll() {
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.LoadingDataPleaseWait });
      var failedDevs = [];
      if (this.selectedDev == undefined) {
        var now = new Date();
        if (this.val.value == now.addMonths(-1).toStringWithFormat("YYMM")) {
          var missing = this.devices.filter((d) => d.mRcvdTo && d.mRcvdTo < Number(this.val.value) && d.lastTalkDate && d.lastTalkDate.addHours(24) > now);
          if (missing && missing.length > 0) {
            await g_Dialog.close();
            this.dialogLoader.showError("Raport lunar lipsa!\n" + TR.Devices + ": " + missing.map((d) => d.sn).join(", "), { timeout: 60000, showCopy: true });
            return;
          }
        }
        var devz = this.devices.filter((d) => !!d.lastTalkDate);
        for (var d = 0; d < devz.length; d++) {
          var dev = this.devices[d];
          if (!(await this.download(dev.sn))) {
            failedDevs.push(dev.sn);
          }
        }
      } else {
        if (!(await this.download(this.selectedDev.sn))) {
          failedDevs.push(this.selectedDev);
        }
      }

      await g_Dialog.close();
      if (failedDevs.length > 0) {
        this.dialogLoader.showError("Eroare de incarcare XML!\n" + TR.Devices + ": " + failedDevs.join(", "), { timeout: 60000, showCopy: true });
      }
    },
    async download(sn) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: sn + " " + TR.LoadingDataPleaseWait });
          HTTPSender.SendGETreq(DataManager.RO_IIS_SERVER_URL, "/WebPms/GTA/GetNRAXML/" + sn + "/" + this.val.value, "blob")
            .done(async (response) => {
              if (response == "42" || response.success == false) {
                resolve(false);
              } else {
                this.saveXml(response, this.val.value + "_" + sn + ".zip");
                resolve(true);
              }
            })
            .fail(() => {
              resolve(false);
            });
        }, 500);
      });
    },
    saveXml(data, fileName) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      this.$nextTick(() => {
        var blob = new Blob([data], {
          type: "octet/stream",
        });
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    },
  },
  mounted() {
    var dt = new Date();
    for (var i = 0; i < 6; i++) {
      dt = dt.addMonths(-1);
      if (dt.getFullYear() == 2024) break;
      //   this.MM_YY.push({ name: dt.getFullYear() + " " + DataManager.MonthNames[dt.getMonth()], value: (dt.getFullYear() - 2000).toString() + (dt.getMonth() + 1).toString().padStart(2, "0") });
      this.MM_YY.push({ name: dt.getFullYear() + " " + DataManager.MonthNames[dt.getMonth()], value: dt.toStringWithFormat("YYMM") });
    }
  },
};
</script>

<style>
</style>